import Feedback from "../singleton/feedback";

export default {

    getKeys: Feedback.getKeys.bind(Feedback),

    deleteKey: Feedback.deleteKey.bind(Feedback),

    getResult: Feedback.getResult.bind(Feedback),

    getDetails: Feedback.getDetails.bind(Feedback)

};